// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
export const getLegendDefaultProps = () => ({
    iconType: 'circle',
    iconSize: 12,
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'top',
});
const Legend = (props) => null;
export default Legend;
